var Share = {
	node :null,
	isOpen: false,

	init: function() {
		var url = window.location.href;
		var title = document.getElementsByTagName("title")[0].innerHTML;

		Share.node = $(TPL.render("share-main", {"url": url, "title": title}));
		$("#overlay").append(this.node);

		Share.icon = Menu.prepIcon('fas fa-share-alt', TPL.lng("tips.share", "Udostępnij"), 'HTML5.tips.share', {"sub": 0, "subsel": ".items", "itemsel": "a", "toggle": Share.toggle, "node": this.node});

		AppEvent.on(player, "MENU.REBUILD", function() {
			Share.icon.children('a').on('click', Share.toggle);
		});

	},

	toggle: function() {
			Share.isOpen = !Share.isOpen;
			if (Share.isOpen) {
				Share.node.show();
				setTimeout(function() {$("body").one("click", Share.clickOut);}, 200);
			} else {
				Share.node.hide();
			}
	},

	clickOut: function() {
		if (Share.isOpen) {
			Share.node.hide();
			Share.isOpen = false;
		}
	},

	placeReady: function(pe) {
	},
}

PluginManager.add(Share);